var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4444 4.5999V1.33324C12.4444 0.819902 12.0444 0.399902 11.5556 0.399902H0.888889C0.4 0.399902 0 0.819902 0 1.33324V10.6666C0 11.1799 0.4 11.5999 0.888889 11.5999H11.5556C12.0444 11.5999 12.4444 11.1799 12.4444 10.6666V7.3999L16 11.1332V0.866569L12.4444 4.5999Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.cc8bbfcb9dc1f12f1f31224fc1b0a73e.svg";
export { ForwardRef as ReactComponent };